import React from 'react';
import EntityConfigSection from "../../Components/EntityConfigSection";
import ClipboardProvider from "../../../../Hooks/Clipboard/ClipboardProvider";
import AvailabilityOverridesSection from "./AvailabilityOverridesSection";
import AvailabilitySection from "./AvailabilitySection";

const EntityAvailabilityConfig = (props) => {

    return (
        <EntityConfigSection
            title="Availability"
            isExpanded={props.isExpanded}
            wide
        >
            <ClipboardProvider>
                <AvailabilitySection
                    config={props.config}
                    errors={props.errors}
                    onChange={props.onChange}
                />

                <AvailabilityOverridesSection
                    config={props.config}
                    errors={props.errors}
                    onChange={props.onChange}
                    onChanges={props.onChanges}
                />
            </ClipboardProvider>

        </EntityConfigSection>
    )
}

export default EntityAvailabilityConfig;
